export default __webpack_public_path__ + "static/media/red-ship.e99b56d3.png";